import { SaveDialogContent, SaveButton } from "@/components/SaveForm";
import { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { Dialog, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

const inp = "bg-slate-950 border-slate-700 text-slate-100 mt-1";

export function ChangePasswordDialog({ open, onOpenChange }) {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [cf, setCf] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (nw.length < 6) { toast.error("A nova senha deve ter ao menos 6 caracteres."); return; }
    if (nw !== cf) { toast.error("A nova senha e a confirmação não conferem."); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: cur, new_password: nw, confirm_password: cf });
      if (data.token) localStorage.setItem("almox_token", data.token);
      toast.success("Senha alterada com sucesso.");
      setCur(""); setNw(""); setCf(""); onOpenChange(false);
    } catch (e) { toast.error(apiErr(e)); } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <SaveDialogContent className="bg-slate-900 border-slate-700 text-slate-100">
        <DialogHeader><DialogTitle className="font-display text-2xl flex items-center gap-2"><KeyRound className="h-6 w-6" /> Alterar senha</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Senha atual</Label><Input data-testid="input-current-password" type="password" value={cur} onChange={(e) => setCur(e.target.value)} className={inp} /></div>
          <div><Label>Nova senha</Label><Input data-testid="input-new-password" type="password" value={nw} onChange={(e) => setNw(e.target.value)} className={inp} /></div>
          <div><Label>Confirmar nova senha</Label><Input data-testid="input-confirm-password" type="password" value={cf} onChange={(e) => setCf(e.target.value)} className={inp} /></div>
        </div>
        <DialogFooter><Button variant="ghost" onClick={() => onOpenChange(false)}>Cancelar</Button><SaveButton data-testid="btn-change-password-submit" onClick={submit} disabled={loading} className="bg-sky-700 hover:bg-sky-600">{loading ? "Salvando..." : "Alterar senha"}</SaveButton></DialogFooter>
      </SaveDialogContent>
    </Dialog>
  );
}
